import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";

/**
 * Listens for route changes and, if the current path matches a server-side
 * redirect, navigates to the new path. Backend tracks hit counts.
 *
 * This is the SPA equivalent of a 301 (the URL really does change in the
 * browser address bar, and search engines re-discover the new path on the
 * next crawl via the sitemap).
 *
 * Skipped on admin/tenant/api paths to avoid loops & overhead.
 */
const SKIP_PREFIXES = ["/admin", "/locataire", "/api", "/reserver", "/paiement"];

export const RedirectGate = ({ children }) => {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (SKIP_PREFIXES.some(p => pathname.startsWith(p))) return;
    let cancelled = false;
    api.get(`/redirects/lookup?path=${encodeURIComponent(pathname)}`).then(r => {
      if (cancelled) return;
      const redirect = r?.data?.redirect;
      if (!redirect || !redirect.to_path) return;
      const target = redirect.to_path;
      if (target === pathname) return; // safety
      if (target.startsWith("http")) {
        window.location.replace(target);
      } else {
        navigate(target + (search || ""), { replace: true });
      }
    }).catch(() => {});
    return () => { cancelled = true; };
  }, [pathname, search, navigate]);

  return children;
};

export default RedirectGate;
